import { PortableText } from '@portabletext/react'

import styles from './SanityPortableText.module.css'

const SanityPortableText = ({ content }: { content: any[] }): React.ReactElement => {
  return (
    <section className={`px-2 sm:px-4 xl:px-6 ${styles.default}`}>
      <PortableText value={content} />
    </section>
  )
}

export default SanityPortableText
